var styles = {
  "rs-reset-letter-spacing": "_rs-reset-letter-spacing_tfgi0h_1",
  "rs-typography_theme_light": "_rs-typography_theme_light_tfgi0h_1",
  "rs-typography_theme_dark": "_rs-typography_theme_dark_tfgi0h_1",
  "rs-text_hardness_hard": "_rs-text_hardness_hard_tfgi0h_1",
  "rs-text_hardness_average": "_rs-text_hardness_average_tfgi0h_1",
  "rs-text_hardness_pale": "_rs-text_hardness_pale_tfgi0h_1",
  "rs-text_hardness_auto": "_rs-text_hardness_auto_tfgi0h_1",
  "rs-text_color_hard": "_rs-text_color_hard_tfgi0h_1",
  "rs-text_color_average": "_rs-text_color_average_tfgi0h_1",
  "rs-text_color_pale": "_rs-text_color_pale_tfgi0h_1",
  "rs-text_color_base": "_rs-text_color_base_tfgi0h_1",
  "rs-digits-1": "_rs-digits-1_tfgi0h_1",
  "rs-digits-2": "_rs-digits-2_tfgi0h_1",
  "rs-super-hero": "_rs-super-hero_tfgi0h_1",
  "rs-middle-hero": "_rs-middle-hero_tfgi0h_1",
  "rs-hero": "_rs-hero_tfgi0h_1",
  "rs-h1": "_rs-h1_tfgi0h_1",
  "rs-h2": "_rs-h2_tfgi0h_1",
  "rs-h3": "_rs-h3_tfgi0h_1",
  "rs-h4": "_rs-h4_tfgi0h_1",
  "rs-h5": "_rs-h5_tfgi0h_1",
  "rs-subtitle-1": "_rs-subtitle-1_tfgi0h_1",
  "rs-subtitle-2": "_rs-subtitle-2_tfgi0h_1",
  "rs-overline": "_rs-overline_tfgi0h_1",
  "rs-text-1": "_rs-text-1_tfgi0h_1",
  "rs-text-2": "_rs-text-2_tfgi0h_1",
  "rs-text-3": "_rs-text-3_tfgi0h_1",
  "rs-digits-1_theme_light": "_rs-digits-1_theme_light_tfgi0h_1",
  "rs-digits-2_theme_light": "_rs-digits-2_theme_light_tfgi0h_1",
  "rs-super-hero_theme_light": "_rs-super-hero_theme_light_tfgi0h_1",
  "rs-middle-hero_theme_light": "_rs-middle-hero_theme_light_tfgi0h_1",
  "rs-hero_theme_light": "_rs-hero_theme_light_tfgi0h_1",
  "rs-h1_theme_light": "_rs-h1_theme_light_tfgi0h_1",
  "rs-h2_theme_light": "_rs-h2_theme_light_tfgi0h_1",
  "rs-h3_theme_light": "_rs-h3_theme_light_tfgi0h_1",
  "rs-h4_theme_light": "_rs-h4_theme_light_tfgi0h_1",
  "rs-h5_theme_light": "_rs-h5_theme_light_tfgi0h_1",
  "rs-subtitle-1_theme_light": "_rs-subtitle-1_theme_light_tfgi0h_1",
  "rs-subtitle-2_theme_light": "_rs-subtitle-2_theme_light_tfgi0h_1",
  "rs-text-1_theme_light": "_rs-text-1_theme_light_tfgi0h_1",
  "rs-text-2_theme_light": "_rs-text-2_theme_light_tfgi0h_1",
  "rs-text-3_theme_light": "_rs-text-3_theme_light_tfgi0h_1",
  "rs-overline_theme_light": "_rs-overline_theme_light_tfgi0h_1",
  "rs-digits-1_theme_dark": "_rs-digits-1_theme_dark_tfgi0h_1",
  "rs-digits-2_theme_dark": "_rs-digits-2_theme_dark_tfgi0h_1",
  "rs-super-hero_theme_dark": "_rs-super-hero_theme_dark_tfgi0h_1",
  "rs-middle-hero_theme_dark": "_rs-middle-hero_theme_dark_tfgi0h_1",
  "rs-hero_theme_dark": "_rs-hero_theme_dark_tfgi0h_1",
  "rs-h1_theme_dark": "_rs-h1_theme_dark_tfgi0h_1",
  "rs-h2_theme_dark": "_rs-h2_theme_dark_tfgi0h_1",
  "rs-h3_theme_dark": "_rs-h3_theme_dark_tfgi0h_1",
  "rs-h4_theme_dark": "_rs-h4_theme_dark_tfgi0h_1",
  "rs-h5_theme_dark": "_rs-h5_theme_dark_tfgi0h_1",
  "rs-subtitle-1_theme_dark": "_rs-subtitle-1_theme_dark_tfgi0h_1",
  "rs-subtitle-2_theme_dark": "_rs-subtitle-2_theme_dark_tfgi0h_1",
  "rs-text-1_theme_dark": "_rs-text-1_theme_dark_tfgi0h_1",
  "rs-text-2_theme_dark": "_rs-text-2_theme_dark_tfgi0h_1",
  "rs-text-3_theme_dark": "_rs-text-3_theme_dark_tfgi0h_1",
  "rs-overline_theme_dark": "_rs-overline_theme_dark_tfgi0h_1",
  "rs-digits-1_theme_auto": "_rs-digits-1_theme_auto_tfgi0h_1",
  "rs-digits-2_theme_auto": "_rs-digits-2_theme_auto_tfgi0h_1",
  "rs-super-hero_theme_auto": "_rs-super-hero_theme_auto_tfgi0h_1",
  "rs-middle-hero_theme_auto": "_rs-middle-hero_theme_auto_tfgi0h_1",
  "rs-hero_theme_auto": "_rs-hero_theme_auto_tfgi0h_1",
  "rs-h1_theme_auto": "_rs-h1_theme_auto_tfgi0h_1",
  "rs-h2_theme_auto": "_rs-h2_theme_auto_tfgi0h_1",
  "rs-h3_theme_auto": "_rs-h3_theme_auto_tfgi0h_1",
  "rs-h4_theme_auto": "_rs-h4_theme_auto_tfgi0h_1",
  "rs-h5_theme_auto": "_rs-h5_theme_auto_tfgi0h_1",
  "rs-subtitle-1_theme_auto": "_rs-subtitle-1_theme_auto_tfgi0h_1",
  "rs-subtitle-2_theme_auto": "_rs-subtitle-2_theme_auto_tfgi0h_1",
  "rs-text-1_theme_auto": "_rs-text-1_theme_auto_tfgi0h_1",
  "rs-text-2_theme_auto": "_rs-text-2_theme_auto_tfgi0h_1",
  "rs-text-3_theme_auto": "_rs-text-3_theme_auto_tfgi0h_1",
  "rs-overline_theme_auto": "_rs-overline_theme_auto_tfgi0h_1",
  "rs-text-1_hardness_hard": "_rs-text-1_hardness_hard_tfgi0h_1",
  "rs-text-2_hardness_hard": "_rs-text-2_hardness_hard_tfgi0h_1",
  "rs-text-3_hardness_hard": "_rs-text-3_hardness_hard_tfgi0h_1",
  "rs-text-1_hardness_average": "_rs-text-1_hardness_average_tfgi0h_1",
  "rs-text-2_hardness_average": "_rs-text-2_hardness_average_tfgi0h_1",
  "rs-text-3_hardness_average": "_rs-text-3_hardness_average_tfgi0h_1",
  "rs-text-1_hardness_pale": "_rs-text-1_hardness_pale_tfgi0h_1",
  "rs-text-2_hardness_pale": "_rs-text-2_hardness_pale_tfgi0h_1",
  "rs-text-3_hardness_pale": "_rs-text-3_hardness_pale_tfgi0h_1",
  "rs-text-1_paragraph-offset-auto": "_rs-text-1_paragraph-offset-auto_tfgi0h_1",
  "rs-text-2_paragraph-offset-auto": "_rs-text-2_paragraph-offset-auto_tfgi0h_1",
  "rs-text-3_paragraph-offset-auto": "_rs-text-3_paragraph-offset-auto_tfgi0h_1",
  "rs-text_paragraph-offset-auto": "_rs-text_paragraph-offset-auto_tfgi0h_1",
  "rs-ul": "_rs-ul_tfgi0h_1",
  "rs-ol": "_rs-ol_tfgi0h_1",
  "rs-ul_offset-items_8": "_rs-ul_offset-items_8_tfgi0h_1",
  "rs-ol_offset-items_8": "_rs-ol_offset-items_8_tfgi0h_1",
  "rs-ul_offset-items_12": "_rs-ul_offset-items_12_tfgi0h_1",
  "rs-ol_offset-items_12": "_rs-ol_offset-items_12_tfgi0h_1",
  "rs-ul_offset-items_16": "_rs-ul_offset-items_16_tfgi0h_1",
  "rs-ol_offset-items_16": "_rs-ol_offset-items_16_tfgi0h_1",
  "rs-ul_offset-items_24": "_rs-ul_offset-items_24_tfgi0h_1",
  "rs-ol_offset-items_24": "_rs-ol_offset-items_24_tfgi0h_1",
  "rs-ol_alpha_lower": "_rs-ol_alpha_lower_tfgi0h_1",
  "rs-ol_alpha_upper": "_rs-ol_alpha_upper_tfgi0h_1",
  "rs-code": "_rs-code_tfgi0h_1",
  "rs-pre": "_rs-pre_tfgi0h_1",
  "rs-link_mode_classic": "_rs-link_mode_classic_tfgi0h_1",
  "rs-link_mode_rock": "_rs-link_mode_rock_tfgi0h_1",
  "rs-link_mode_standalone": "_rs-link_mode_standalone_tfgi0h_1",
  "rs-link_mode_clear": "_rs-link_mode_clear_tfgi0h_1",
  "rs-link_hardness_hard": "_rs-link_hardness_hard_tfgi0h_1",
  "rs-link_hardness_average": "_rs-link_hardness_average_tfgi0h_1",
  "rs-link_hardness_pale": "_rs-link_hardness_pale_tfgi0h_1",
  "rs-link_external": "_rs-link_external_tfgi0h_1",
  "rs-link": "_rs-link_tfgi0h_1",
  "rs-code_theme_light": "_rs-code_theme_light_tfgi0h_1",
  "rs-pre_theme_light": "_rs-pre_theme_light_tfgi0h_1",
  "rs-link_theme_light": "_rs-link_theme_light_tfgi0h_1",
  "rs-code_theme_dark": "_rs-code_theme_dark_tfgi0h_1",
  "rs-pre_theme_dark": "_rs-pre_theme_dark_tfgi0h_1",
  "rs-link_theme_dark": "_rs-link_theme_dark_tfgi0h_1",
  "rs-code_theme_auto": "_rs-code_theme_auto_tfgi0h_1",
  "rs-pre_theme_auto": "_rs-pre_theme_auto_tfgi0h_1",
  "rs-link_theme_auto": "_rs-link_theme_auto_tfgi0h_1"
};
export { styles as default };
